const milan = [
  {
    id: 0,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 26/27 - Uniforme 1",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2026", "2026 milan", "2026"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/26-27-04/uni0.jpg",
      "/images/europa/milan/26-27-04/uni1.jpg",
      "/images/europa/milan/26-27-04/uni2.jpg",
      "/images/europa/milan/26-27-04/uni3.jpg",
      "/images/europa/milan/26-27-04/uni4.jpg",
    ],
  },
  {
    id: 1,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2025", "2025 milan", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/25-26-01/uni0.jpg",
      "/images/europa/milan/25-26-01/uni1.jpg",
      "/images/europa/milan/25-26-01/uni2.jpg",
      "/images/europa/milan/25-26-01/uni3.jpg",
      "/images/europa/milan/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2025", "2025 milan", "2025"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/25-26-02/uni0.jpg",
      "/images/europa/milan/25-26-02/uni1.jpg",
      "/images/europa/milan/25-26-02/uni2.jpg",
      "/images/europa/milan/25-26-02/uni3.jpg",
      "/images/europa/milan/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2024", "2024 milan", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/24-25-01/uni0.jpg",
      "/images/europa/milan/24-25-01/uni1.jpg",
      "/images/europa/milan/24-25-01/uni2.jpg",
      "/images/europa/milan/24-25-01/uni3.jpg",
      "/images/europa/milan/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2024", "2024 milan", "2024"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/24-25-02/uni0.jpg",
      "/images/europa/milan/24-25-02/uni1.jpg",
      "/images/europa/milan/24-25-02/uni2.jpg",
      "/images/europa/milan/24-25-02/uni3.jpg",
      "/images/europa/milan/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 22/23 - Uniforme 1",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2022", "2022 milan", "2022"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/22-23-01/uni0.jpg",
      "/images/europa/milan/22-23-01/uni1.jpg",
      "/images/europa/milan/22-23-01/uni2.jpg",
      "/images/europa/milan/22-23-01/uni3.jpg",
      "/images/europa/milan/22-23-01/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 22/23 - Uniforme 3",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2022", "2022 milan", "2022"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/22-23-03/uni0.jpg",
      "/images/europa/milan/22-23-03/uni1.jpg",
      "/images/europa/milan/22-23-03/uni2.jpg",
      "/images/europa/milan/22-23-03/uni3.jpg",
      "/images/europa/milan/22-23-03/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2021", "2021 milan", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/21-21-01/uni0.jpg",
      "/images/europa/milan/21-21-01/uni1.jpg",
      "/images/europa/milan/21-21-01/uni2.jpg",
      "/images/europa/milan/21-21-01/uni3.jpg",
      "/images/europa/milan/21-21-01/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2021", "2021 milan", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/21-22-02/uni0.jpg",
      "/images/europa/milan/21-22-02/uni1.jpg",
      "/images/europa/milan/21-22-02/uni2.jpg",
      "/images/europa/milan/21-22-02/uni3.jpg",
      "/images/europa/milan/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 21/22 - Uniforme 3",
    tipo: "masculino",
    aliases: ["milan", "rossoneri ", "milan 2021", "2021 milan", "2021"],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/21-22-03/uni0.jpg",
      "/images/europa/milan/21-22-03/uni1.jpg",
      "/images/europa/milan/21-22-03/uni2.jpg",
      "/images/europa/milan/21-22-03/uni3.jpg",
      "/images/europa/milan/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 14/15 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2014",
      "2014 milan",
      "2014",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/14-15-01-rt/uni0.jpg",
      "/images/europa/milan/14-15-01-rt/uni1.jpg",
      "/images/europa/milan/14-15-01-rt/uni2.jpg",
      "/images/europa/milan/14-15-01-rt/uni3.jpg",
      "/images/europa/milan/14-15-01-rt/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 13/14 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2013",
      "2013 milan",
      "2013",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/13-14-01-rt/uni0.jpg",
      "/images/europa/milan/13-14-01-rt/uni1.jpg",
      "/images/europa/milan/13-14-01-rt/uni2.jpg",
      "/images/europa/milan/13-14-01-rt/uni3.jpg",
      "/images/europa/milan/13-14-01-rt/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 12/13 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2012",
      "2012 milan",
      "2012",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/12-13-01-rt/uni0.jpg",
      "/images/europa/milan/12-13-01-rt/uni1.jpg",
      "/images/europa/milan/12-13-01-rt/uni2.jpg",
      "/images/europa/milan/12-13-01-rt/uni3.jpg",
      "/images/europa/milan/12-13-01-rt/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 11/12 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2011",
      "2011 milan",
      "2011",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/11-12-01-rt/uni0.jpg",
      "/images/europa/milan/11-12-01-rt/uni1.jpg",
      "/images/europa/milan/11-12-01-rt/uni2.jpg",
      "/images/europa/milan/11-12-01-rt/uni3.jpg",
      "/images/europa/milan/11-12-01-rt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 10/11 - Uniforme 1 Retrô Manga Longa",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2010",
      "2010 milan",
      "2010",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/10-11-01-rt/uni0.jpg",
      "/images/europa/milan/10-11-01-rt/uni1.jpg",
      "/images/europa/milan/10-11-01-rt/uni2.jpg",
      "/images/europa/milan/10-11-01-rt/uni3.jpg",
      "/images/europa/milan/10-11-01-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 09/10 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2009",
      "2009 milan",
      "2009",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/09-10-01-rt/uni0.jpg",
      "/images/europa/milan/09-10-01-rt/uni1.jpg",
      "/images/europa/milan/09-10-01-rt/uni2.jpg",
      "/images/europa/milan/09-10-01-rt/uni3.jpg",
      "/images/europa/milan/09-10-01-rt/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 07/08 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2007",
      "2007 milan",
      "2007",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/07-08-02-rt/uni0.jpg",
      "/images/europa/milan/07-08-02-rt/uni1.jpg",
      "/images/europa/milan/07-08-02-rt/uni2.jpg",
      "/images/europa/milan/07-08-02-rt/uni3.jpg",
      "/images/europa/milan/07-08-02-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 06/07 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2006",
      "2006 milan",
      "2006",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/06-07-01-rt/uni0.jpg",
      "/images/europa/milan/06-07-01-rt/uni1.jpg",
      "/images/europa/milan/06-07-01-rt/uni2.jpg",
      "/images/europa/milan/06-07-01-rt/uni3.jpg",
      "/images/europa/milan/06-07-01-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 06/07 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2006",
      "2006 milan",
      "2006",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/06-07-02-rt/uni0.jpg",
      "/images/europa/milan/06-07-02-rt/uni1.jpg",
      "/images/europa/milan/06-07-02-rt/uni2.jpg",
      "/images/europa/milan/06-07-02-rt/uni3.jpg",
      "/images/europa/milan/06-07-02-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 04/05 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2004",
      "2004 milan",
      "2004",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/04-05-01-rt/uni0.jpg",
      "/images/europa/milan/04-05-01-rt/uni1.jpg",
      "/images/europa/milan/04-05-01-rt/uni2.jpg",
      "/images/europa/milan/04-05-01-rt/uni3.jpg",
      "/images/europa/milan/04-05-01-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 00/01 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 2000",
      "2000 milan",
      "2000",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/00-01-01-rt/uni0.jpg",
      "/images/europa/milan/00-01-01-rt/uni1.jpg",
      "/images/europa/milan/00-01-01-rt/uni2.jpg",
      "/images/europa/milan/00-01-01-rt/uni3.jpg",
      "/images/europa/milan/00-01-01-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 98/99 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 1998",
      "1998 milan",
      "1998",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/98-99-02-rt/uni0.jpg",
      "/images/europa/milan/98-99-02-rt/uni1.jpg",
      "/images/europa/milan/98-99-02-rt/uni2.jpg",
      "/images/europa/milan/98-99-02-rt/uni3.jpg",
      "/images/europa/milan/98-99-02-rt/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 97/98 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 1997",
      "1997 milan",
      "1997",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/97-98-02-rt/uni0.jpg",
      "/images/europa/milan/97-98-02-rt/uni1.jpg",
      "/images/europa/milan/97-98-02-rt/uni2.jpg",
      "/images/europa/milan/97-98-02-rt/uni3.jpg",
      "/images/europa/milan/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 97/98 - Uniforme 3 Retrô",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 1997",
      "1997 milan",
      "1997",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/97-98-03-rt/uni0.jpg",
      "/images/europa/milan/97-98-03-rt/uni1.jpg",
      "/images/europa/milan/97-98-03-rt/uni2.jpg",
      "/images/europa/milan/97-98-03-rt/uni3.jpg",
      "/images/europa/milan/97-98-03-rt/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan 93/94 - Uniforme 1 Retrô Manga Longa",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan 1993",
      "1993 milan",
      "1993",
      "milan retro",
      "retro milan",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/milan/93-94-01-rt/uni0.jpg",
      "/images/europa/milan/93-94-01-rt/uni1.jpg",
      "/images/europa/milan/93-94-01-rt/uni2.jpg",
      "/images/europa/milan/93-94-01-rt/uni3.jpg",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan jaqueta",
      "jaqueta milan",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/jv/uni0.jpg",
      "/images/europa/milan/jv/uni1.jpg",
      "/images/europa/milan/jv/uni2.jpg",
      "/images/europa/milan/jv/uni3.jpg",
      "/images/europa/milan/jv/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "serie-a",
    time: "milan",
    nome: "Milan - Jaqueta (Vermelha/Preta)",
    tipo: "masculino",
    aliases: [
      "milan",
      "rossoneri ",
      "milan jaqueta",
      "jaqueta milan",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/milan/jvp/uni0.jpg",
      "/images/europa/milan/jvp/uni1.jpg",
      "/images/europa/milan/jvp/uni2.jpg",
      "/images/europa/milan/jvp/uni3.png",
      "/images/europa/milan/jvp/uni4.jpg",
    ],
  },
];

export default milan;
